module.exports = __webpack_public_path__ + "img/portugal-respiratory-diseases-female.ae73eadf.png";